import { Component, cloneElement } from 'react';
import PropTypes from 'prop-types';
import MissingParameters from '../MissingParameters';
import { withRouter } from 'react-router-dom';
import { parse } from 'hub-http/helpers/params';
import { getNormalizedQuery, getMissingParameters } from '../../utils/urls';
import { jsx as _jsx } from "react/jsx-runtime";
class Application extends Component {
  constructor(props) {
    super(props);
    const params = parse(props.location.search.slice(1));
    const normalizedQuery = getNormalizedQuery(params);
    this.missingParameters = getMissingParameters(normalizedQuery);
  }
  render() {
    return /*#__PURE__*/_jsx("div", {
      className: "authorize",
      children: this.missingParameters.length === 0 ? ( /*#__PURE__*/cloneElement(this.props.children)) : /*#__PURE__*/_jsx(MissingParameters, {
        missingParameters: this.missingParameters
      })
    });
  }
}
Application.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string.isRequired
  }).isRequired,
  children: PropTypes.node.isRequired
};
export default withRouter(Application);